module.exports = __webpack_public_path__ + "static/img/bl.38e27b68.svg";